import React from 'react';
import { Tag } from 'ui';

import useChatQuotaUsage from './useChatQuotaUsage';

import './_chat-quota-usage.scss';

type ChatQuotaUsageProps = {
  /** Teacher tools screens: adds the tooltip, which also makes the chip focusable. */
  isTeacher?: boolean;
};

/**
 * "X% used" chip in the chat footer, and top right of the teacher tools panel and tool setup.
 * Renders nothing without a quota, with an unlimited quota or while it could not be read.
 */
function ChatQuotaUsage({ isTeacher = false }: ChatQuotaUsageProps): JSX.Element | null {
  const quotaUsage = useChatQuotaUsage({ isTeacher });

  if (!quotaUsage) {
    return null;
  }

  return (
    <Tag
      className="chat-quota-usage"
      color={quotaUsage.tagColor}
      customTextColor={quotaUsage.textColor}
      label={quotaUsage.label}
      tooltip={quotaUsage.tooltip}
    />
  );
}

export default ChatQuotaUsage;
